import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// --- Auto-refresh on 401 ---
let refreshPromise = null;

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (!original || original.__isRetryRequest) {
      return Promise.reject(error);
    }
    const status = error.response?.status;
    const url = original.url || '';
    // Ne pas tenter de refresh sur les endpoints d'auth eux-mêmes ou hors API
    if (status !== 401) return Promise.reject(error);
    if (url.includes('/api/auth/login') || url.includes('/api/auth/refresh') || url.includes('/api/auth/logout')) {
      return Promise.reject(error);
    }

    try {
      if (!refreshPromise) {
        refreshPromise = axios.post(`${API_URL}/api/auth/refresh`, {}, { withCredentials: true })
          .finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      original.__isRetryRequest = true;
      return axios(original);
    } catch (refreshErr) {
      // Session terminée : l'écran de connexion s'affiche avec un message, puis ramène à la page en cours (16/10/2026)
      if (!url.includes('/api/auth/me')) window.dispatchEvent(new Event('dmo-session-expiree'));   // pas à l'ouverture de l'application
      return Promise.reject(error);
    }
  }
);
